import { render, staticRenderFns } from "./analytics-quickview.vue?vue&type=template&id=5b64e6ce&scoped=true&"
import script from "./analytics-quickview.vue?vue&type=script&lang=js&"
export * from "./analytics-quickview.vue?vue&type=script&lang=js&"
import style0 from "./analytics-quickview.vue?vue&type=style&index=0&id=5b64e6ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b64e6ce",
  null
  
)

export default component.exports